module.exports = __webpack_public_path__ + "static/img/48002.8a7a63c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48002.jpg
// module id = fCl9
// module chunks = 1